import {
  Typography,
  Spin,
  Input,
  Row,
  Col,
  Card,
  Button,
  notification,
} from 'antd';
import DF from 'DisplayFramework';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import {
  FinCTListResponse,
  FindFinCTByAnyRefOrStatusOrDateParams,
  findFinCTByAnyRefOrStatusOrDate,
} from 'services/fincontract';
import { useQuery } from 'react-query';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { ControlTwoTone ,DownloadOutlined} from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import ParListSelect from 'components/ParListSelect';
import { useParams } from 'react-router-dom';
import GetLabel from 'DisplayFramework/components/GetLabel';
const { Text } = Typography;
type DealerContractsProps = {};
const DealerContracts = (props: DealerContractsProps) => {
  let { status } = useParams<{
    status: 'TERMINATED' | 'ALL';
  }>();
  const clientname = localStorage?.getItem('name');
  const initialSearchParams: FindFinCTByAnyRefOrStatusOrDateParams = {
    propreference: '',
    tpreference: '',
    clientname: clientname || '',
    prcode: '',
    offerid: 0,
    ctphase: '',
    ctstatus: status === 'ALL' ? '' : status || '',
    tprefbroker: '',
    brokername: '',
    network: '',
    branchid: 0,
    marketingid: 0,
    tpidbroker: 0,
    datemin: '',
    datemax: '',
    ctreference: '',
    clientreference: '',
  };
  const [searchParams, setSearchParams] =
    useState<FindFinCTByAnyRefOrStatusOrDateParams>({
      ...initialSearchParams,
    });
  const [searchs, setsearchs] = useState(false);
  const { data, isLoading, refetch } = useQuery(
    ['findFinCTByAnyRefOrStatusOrDate', searchParams],
    () =>
      findFinCTByAnyRefOrStatusOrDate(searchParams).then(
        (res) => res.list || []
      ),
    {}
  );
  useEffect(() => {
    searchProposal('', searchParams.clientname, searchParams.ctstatus);

  }, [searchParams.ctstatus]);
  const [listProposal, setListProposal] = useState<any[]>([]);
  const searchProposal = useCallback(
    (reference: string, clientname: string, ctstatus: string) => {
      findFinCTByAnyRefOrStatusOrDate({
        ...searchParams,
        ctreference: reference,
        clientname: clientname,
        ctstatus: ctstatus,
      })
        .then((response) => {
          if (response.code === '200') {
            setListProposal(response.list);
          } else {
            // notification.error({
            //   message: response.message,
            // });
            setListProposal([]);
          }
        })
        .catch((response) => {
          notification.error({
            message: response.message,
          });
          setListProposal([]);
        });
    },
    [isLoading]
  );
  const columns = useMemo<DataGridColDef<FinCTListResponse>[]>(
    () => [
      {
        dataIndex: 'ctreference',
        width: 200,
        filtrable: 'ctreference',
      },
      {
        dataIndex: 'clientname',
        width: 200,
        filtrable: 'clientname',
      },
      {
        dataIndex: 'ctactivationdate',
        width: 200,
        render: (date) => date.slice(0, 10),
      },
      {
        dataIndex: 'ctfinancedamount',
        width: 200,
      },
      {
        dataIndex: 'statuslabel',
        width: 200,
        filtrable: 'ctstatus',
        filterComponent: (
          <ParListSelect parcode="CTSTATUS" style={{ width: '100%' }} disabled={status==='TERMINATED'}/>
        ),
      },
      {
        dataIndex: 'offeridlabel',
        width: 200,
      },
      {
        dataIndex: 'prcodelabel',
        width: 200,
      },
    ],
    [refetch]
  );
  const assetkeywordChange = (e: any) => {
    if (e.target.value.length < 4) {
      setsearchs(true);
      searchProposal(
        e.target.value,
        searchParams.clientname,
        searchParams.ctstatus
      );
    }
  };
  const [hidefilter, setHidefilter] = useState(true);
  return (
    <DF.Provider pagcode="dealercontract">
      <Spin spinning={isLoading}>
        <Card>
          <Row gutter={8} style={{ marginBottom: '1rem' }}>
            <Col span={12}></Col>

            <Col span={3}>
              <CSVLink data={listProposal as any} filename="listOfContract.csv">
                <Button
                  style={{ width: '100%', height: '100% ' }}
                  icon={<DownloadOutlined />}
                >
                  <GetLabel label='extractData'/></Button>
              </CSVLink>
            </Col>
            <Col span={6}>
              <Input
                placeholder="Enter conract's reference"
                onChange={(e) => {
                  assetkeywordChange(e);
                  setsearchs(true);
                }}
              ></Input>
            </Col>
            <Col span={3}>
              <Button
                onClick={() => {
                  setHidefilter(!hidefilter);
                }}
                icon={<ControlTwoTone />}
                style={{ width: '100%', height: '100%' }}
              >
                 <GetLabel label='filter'/>
                
              </Button>
            </Col>
          </Row>
          <DataGrid
          titleComcode='contract'
            columns={columns}
            dataSource={hidefilter ? listProposal ?? [] : data ?? []}
            rowKey={(record) => record.ctrid}
            onSearch={(values) => {
              setSearchParams({
                ...values,
              });
              setsearchs(true);
              refetch();
            }}
            hideFilters={hidefilter}
            initialSearchValues={initialSearchParams}
          />
        </Card>
      </Spin>
    </DF.Provider>
  );
};
export default DealerContracts;
